import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { Anomaly, Cattle, CattleNode, Equipment, Model, NitratesDeclaration, Print, Region, TreatmentLine } from "./models/NDModel";

export default class NDVuexModule extends AbacoVuexModule {
    @State({ default: 0 }) stepStateCounter!: number;
    @State({ default: false }) recalculate!: boolean;
    @State({ default: false }) canView!: boolean;
    @State({ default: false }) canEdit!: boolean;
    @State({ default: false }) isLocked!: boolean;
    @State({ default: [] }) nds!: NitratesDeclaration[];
    @State() currentND!: NitratesDeclaration;
    @State() regions!: Region[];
    @State() treatmentLines!: TreatmentLine[];
    @State() models!: Model[];
    @State() cattles!: Cattle[];
    @State() cattleNodes!: CattleNode[];
    @State({ default: [] }) lots!: any[]; // CHANGE ME
    @State({ default: [] }) availableMachines!: Equipment[]; // CHANGE ME
    @State({ default: null }) selectedPlots!: any; // CHANGE ME
    @State({ default: [] }) availablePlots!: any;
    @State({ default: [] }) prints!: Print[];
    @State({ default: [] }) anomalies!: Anomaly[];
}
